import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../contexts/auth-context";

export const AuthGuard = ({ invert }) => {
  const { isInitialized, isAuthenticated } = useContext(AuthContext);
  let location = useLocation();
  if (!isInitialized) {
    return null;
  }
  if ((!invert && isAuthenticated) || (invert && !isAuthenticated)) {
    return <Outlet />;
  }
  return <Navigate to="/" state={{ from: location }} replace />;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
